<template>
  <div class="rte" :class="{ focus: focused }">
    <div class="bar" @mousedown.prevent>
      <button type="button" title="加粗" @click="cmd('bold')"><b>B</b></button>
      <button type="button" title="斜体" @click="cmd('italic')"><i>I</i></button>
      <button type="button" title="下划线" @click="cmd('underline')"><u>U</u></button>
      <span class="sep" />
      <button type="button" title="标题" @click="cmd('formatBlock', 'h3')">H</button>
      <button type="button" title="引用" @click="cmd('formatBlock', 'blockquote')">❝</button>
      <button type="button" title="无序列表" @click="cmd('insertUnorderedList')">• 列表</button>
      <button type="button" title="有序列表" @click="cmd('insertOrderedList')">1. 列表</button>
      <span class="sep" />
      <button type="button" title="链接" @click="insertLink">链接</button>
      <button type="button" title="清除格式" @click="cmd('removeFormat')">清除</button>
    </div>
    <div
      ref="editor"
      class="area"
      :style="{ minHeight: minHeight }"
      contenteditable="true"
      role="textbox"
      :data-placeholder="placeholder"
      @input="onInput"
      @focus="focused = true"
      @blur="focused = false"
      @paste="onPaste"
    />
  </div>
</template>

<script>
export default {
  name: 'RichTextEditor',
  props: {
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: '写点什么…' },
    minHeight: { type: String, default: '140px' },
    /** 文章编辑：保留剪贴板 HTML（后端仍会消毒） */
    allowHtmlPaste: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  data() {
    return { focused: false, syncing: false }
  },
  watch: {
    modelValue(next) {
      if (this.syncing) return
      const el = this.$refs.editor
      if (!el) return
      if (next !== el.innerHTML) el.innerHTML = next || ''
    }
  },
  mounted() {
    if (this.$refs.editor) this.$refs.editor.innerHTML = this.modelValue || ''
  },
  methods: {
    cmd(command, value = null) {
      this.$refs.editor?.focus()
      document.execCommand(command, false, value)
      this.onInput()
    },
    insertLink() {
      const url = window.prompt('输入链接（https://…）', 'https://')
      if (!url) return
      this.cmd('createLink', url)
    },
    onInput() {
      this.syncing = true
      this.$emit('update:modelValue', this.$refs.editor?.innerHTML || '')
      this.$nextTick(() => {
        this.syncing = false
      })
    },
    onPaste(e) {
      const clip = e.clipboardData || window.clipboardData
      if (this.allowHtmlPaste) {
        const html = clip?.getData('text/html')
        if (html && html.trim()) {
          e.preventDefault()
          document.execCommand('insertHTML', false, html)
          this.onInput()
          return
        }
      }
      e.preventDefault()
      const text = clip?.getData('text/plain') || ''
      document.execCommand('insertText', false, text)
    },
    focus() {
      this.$refs.editor?.focus()
    },
    clear() {
      if (this.$refs.editor) this.$refs.editor.innerHTML = ''
      this.$emit('update:modelValue', '')
    }
  }
}
</script>

<style scoped>
.rte {
  border: 1px solid #e5e6eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.rte.focus { border-color: #165dff; box-shadow: 0 0 0 2px rgba(22, 93, 255, 0.12); }
.bar {
  display: flex; flex-wrap: wrap; gap: 4px; align-items: center;
  padding: 6px 8px; border-bottom: 1px solid #f2f3f5; background: #fafbfc;
}
.bar button {
  border: 0; background: transparent; color: #4e5969; border-radius: 4px;
  padding: 4px 8px; cursor: pointer; font-size: 13px; line-height: 1.2;
}
.bar button:hover { background: #e8f3ff; color: #165dff; }
.sep { width: 1px; height: 16px; background: #e5e6eb; margin: 0 2px; }
.area {
  padding: 10px 12px; outline: none; line-height: 1.65; font-size: 14px; color: #1d2129;
  overflow: auto; max-height: 360px;
}
.area:empty:before {
  content: attr(data-placeholder);
  color: #c9cdd4;
}
.area :deep(h3) { margin: 0.6em 0 0.3em; font-size: 16px; }
.area :deep(blockquote) {
  margin: 8px 0; padding: 6px 12px; border-left: 3px solid #bedaff; background: #f7f8fa; color: #4e5969;
}
.area :deep(ul), .area :deep(ol) { margin: 6px 0; padding-left: 22px; }
.area :deep(a) { color: #165dff; }
.area :deep(img) { max-width: 100%; height: auto; }
.area :deep(table) { border-collapse: collapse; width: 100%; font-size: 13px; }
.area :deep(th), .area :deep(td) { border: 1px solid #e5e6eb; padding: 4px 6px; }
</style>
